// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {

	if (wixWindow.formFactor === "Mobile") {

		$w("#clickUs").show();
		$w("#button21").show();	
		$w("#button22").show();	
	}
});

export function button21_click(event) {
if ($w('#text126').collapsed) {
        $w('#text126').expand()  
    }
    else    
        $w('#text126').collapse()
}
	//Add your code for this event here: 


export function button22_click(event) {
if ($w('#text125').collapsed) {
        $w('#text125').expand()  
    }
    else    
        $w('#text125').collapse()
		//Add your code for this event here: 
}